import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../config/endpoints";
import { allBundleDevices } from "../../../mock/dummyData";
import axiosConfig from "../../../utils/axiosConfig";
import { formatBundles } from "../../../utils/format";

const initialState = {
  bundles: null,
  moreBundles: {},
  loading: false,
  error: "",
};

export const getBundles = createAsyncThunk("bundles/fetch", async (payload) => {
  console.log("fetch-bundles-payload", payload);
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await axiosConfig(
    `${endpoints.fetchBundles}?api_key=1&api_secret=1`,
    "post",
    JSON.stringify(payload),
    config
  );
});

const bundleSlice = createSlice({
  name: "bundles",
  initialState,
  reducers: {
    // setMoreBunbles:(state, {payload}) => {
    //   state.moreBundles = payload
    // },
    setMoreBunbles: (state, { payload }) => {
      if (!state.moreBundles || !state.moreBundles.data) {
        state.moreBundles = payload;
      } else {
        const existingData = state.moreBundles.data;
        const newData = payload?.data || [];
    
        state.moreBundles = {
          ...state.moreBundles,
          ...payload,
          data: [...existingData, ...newData],
        };
      }
    }
    
  },
  extraReducers: (builder) => {
    builder.addCase(getBundles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBundles.fulfilled, (state, action) => {
      console.log("api-bundles", action.payload?.data?.data?.data);
      state.loading = false;
      state.bundles = action.payload?.data?.data;
      state.error = "";
    });
    builder.addCase(getBundles.rejected, (state, action) => {
      state.loading = false;
      state.bundles = {};
      state.error = "Error, Failed to load bundles";
    });
  },
});

export default bundleSlice.reducer;
export const {setMoreBunbles} = bundleSlice.actions;
